import { __extends } from "tslib";
import { CopyObjectOutput, CopyObjectRequest } from "../models/index";
import { deserializeAws_restXmlCopyObjectCommand, serializeAws_restXmlCopyObjectCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { getSsecPlugin } from "@aws-sdk/middleware-ssec";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CopyObjectCommand = /** @class */ (function (_super) {
    __extends(CopyObjectCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CopyObjectCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CopyObjectCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getSsecPlugin(configuration));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: CopyObjectRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CopyObjectOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CopyObjectCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlCopyObjectCommand(input, context);
    };
    CopyObjectCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlCopyObjectCommand(output, context);
    };
    return CopyObjectCommand;
}($Command));
export { CopyObjectCommand };
//# sourceMappingURL=CopyObjectCommand.js.map